import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "title-3" }, "Thank you!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Thank your for supporting this project! This is your NFT. Your transaction was successfully completed. ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("View on Opensea")

import AppButton from "@/components/app/AppButton.vue";
import TokenData from "@/components/token/TokenData.vue";
import { computed, unref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MintStepConfirmPurchase',
  props: ["tokens"],
  setup(__props) {

const props = __props


const token = computed(() => {
    const tokens = unref(props.tokens);
    return tokens && tokens.length > 0 ? tokens[0] : undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(TokenData, { token: _unref(token) }, null, 8, ["token"]),
    _createVNode(AppButton, {
      href: 
                'https://testnets.opensea.io/de-DE/assets/mumbai/' +
                _unref(token)?.contract?.id +
                '/' +
                _unref(token)?.id
            ,
      size: "sm",
      "full-width": ""
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["href"])
  ]))
}
}

})